import { useState } from "react";
import { Eye, EyeOff, Circle, CheckCircle2 } from "lucide-react";
import { Input } from "@/components/ui/input";
import { PASSWORD_RULES } from "@/lib/passwordRules";

const PasswordField = ({ value, onChange }) => {
  const [show, setShow] = useState(false);

  return (
    <div className="w-full flex flex-col gap-3">
      <div className="relative w-full">
        <Input
          type={show ? "text" : "password"}
          label="Passwort"
          placeholder="Passwort eingeben"
          value={value}
          onChange={onChange}
          autoComplete="new-password"
          className="border-black"
        />
        <button
          type="button"
          className="absolute right-0 bottom-4 text-[#9e9e9e] hover:text-black transition-colors p-2"
          onClick={() => setShow(!show)}
          tabIndex={-1}
        >
          {show ? <EyeOff className="w-6 h-6" /> : <Eye className="w-6 h-6" />}
        </button>
      </div>
      <div className="flex flex-wrap gap-x-3 gap-y-1.5 w-full">
        {PASSWORD_RULES.map((rule) => {
          const passed = rule.test(value);
          return (
            <div key={rule.key} className="flex items-center gap-1">
              {passed ? (
                <CheckCircle2 className="w-4 h-4 text-primary" />
              ) : (
                <Circle className="w-4 h-4 text-[#ababab]" />
              )}
              <span className="text-[14px] text-black font-medium leading-4">{rule.label}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default PasswordField;
